import React from 'react';
import { Link } from 'react-router-dom';
import { styles } from './SignIn';

// Any address the app doesn't recognise, instead of a blank page
export default function NotFound() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Page not found</h1>
        <p style={styles.text}>
          There's no page at this address. Check the link, or carry on from your dashboard;
          you'll be asked to sign in first if you aren't already.
        </p>
        <Link to="/dashboard" style={{ ...styles.button, display: 'block', textAlign: 'center', textDecoration: 'none' }}>
          Go to the dashboard
        </Link>
      </div>
    </div>
  );
}
